import LeaveTemplateTable from "./LeaveTemplateTable";

const LeaveTemplate = ({ employeeUserId, appUserId }) => {
    return (
        <LeaveTemplateTable employeeUserId={employeeUserId} appUserId={appUserId} />
    )
}

export default LeaveTemplate;